<template>
	<div class="md-layout">

		<div class="md-layout-item md-small-size-100 md-size-100">
			<h3 class="order-title">{{name}}</h3>
		</div>
		<div class="md-layout-item md-small-size-100 md-size-25">
			<md-field>
				<md-select placeholder="ប្រភេទអាជ្ញាបណ្ណ" v-model="company.type">
					<md-option v-for="business in businessList" :value="business.id">{{business.name}}</md-option>
				</md-select>
			</md-field>
		</div>
		<div class="md-layout-item md-small-size-100 md-size-35">
			<md-field>
				<label>លេខអាជ្ញាបណ្ណ</label>
				<md-input type="text" v-model="company.number" />
			</md-field>
		</div>
		<div class="md-layout-item md-small-size-100 md-size-20">
			<md-field>
				<md-select placeholder="ខេត្ត / ក្រុង" v-model="company.location">
					<md-option v-for="location in locationList" :value="location.id">{{location.name}}</md-option>
				</md-select>
			</md-field>
		</div>

		<div class="md-layout-item md-small-size-100 md-size-20">
			<md-field>
				<label>ផ្ទៃក្រទ្បាដី</label>
				<md-input type="number" v-model="company.area" />
			</md-field>
		</div>
		<div class="md-layout-item md-small-size-100 md-size-100">
			<md-field>
				<label>ទីតាំងអាជីវកម្ម</label>
				<md-input type="text" v-model="company.address" />
			</md-field>
		</div>
		<div class="md-layout-item md-small-size-100 md-size-33">
			<md-field>
				<label>ថ្ងៃចេញអាជ្ញាបណ្ណ</label>
				<datetime type="date" v-model="company.issue"></datetime>
				<md-input type="text" style="display: none" v-model="company.issue" />
			</md-field>
		</div>
		<div class="md-layout-item md-small-size-100 md-size-33">
			<md-field>
				<label>ថ្ងៃគិតសុពលភាព</label>
				<datetime type="date" v-model="company.active"></datetime>
				<md-input type="text" style="display: none" v-model="company.active" />
			</md-field>
		</div>
		<div class="md-layout-item md-small-size-100 md-size-33">
			<md-field>
				<label>ថ្ងៃផុតសុពលភាព</label>
				<datetime type="date" v-model="company.expiry"></datetime>
				<md-input type="text" style="display: none" v-model="company.expiry" />
			</md-field>
		</div>
		<md-divider style="margin: 21px 0 21px 0;"></md-divider>
		<div class="md-layout-item md-size-100 text-right">
			<md-button class="md-raised md-primary" @click="newLicense()">បន្តអាជ្ញាបណ្ណថ្មី</md-button>
		</div>

	</div>
</template>
<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getCompany();
			this.getSettings();
		},
		data() {
			return {
				loaded: false,
				name: "",
				company_id: "",
				isValid: false,
				company: {
					location: "",
					type: "",
					address: "",
					area: "",
					issue: "",
					active: "",
					expiry: "",
					number: ""
				},
				locationList: [],
				businessList: []
			}
		},
		methods: {
			getCompany(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/company/get/single/" + this.$route.params.id).then(data => {
					this.name = data.body.data.name
					this.company_id = data.body.data.id
					this.company.address = data.body.data.address
					this.company.area = data.body.data.area
					this.company.location = data.body.data.location_id
					this.company.type = data.body.data.type_id
					this.loaded = true
				})
			},
			getSettings() {
				this.$http.get(this.config.api + "/public/location/get/list/0").then(data => {
					this.locationList = data.body.data
				})
				this.$http.get(this.config.api + "/public/business/get/list/0").then(data => {
					this.businessList = data.body.data
				})
			},
			newLicense() {
				this.$http.post(this.config.api + "/admin/company/new_license", {
					company_id: this.company_id,
					company: this.company,
					issue: (new Date(this.company.issue)).getTime(),
					active: (new Date(this.company.active)).getTime(),
					expiry: (new Date(this.company.expiry)).getTime(),
				}, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(res => {
					if (res.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "បន្តអាជ្ញាបណ្ណថ្មីជោគជ័យ",
							icon: 'done',
							type: 'success'
						})
						// this.clear();
						// this.checkValidation();
						this.$router.push('/companies/view/' + this.$route.params.id);
					}
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Packages/New.vue